{
    "sydneytrains": {
        "basePath": ""
    }
}
